import React from 'react';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { Carousel } from 'react-responsive-carousel';
import { images } from '../../constants';
import './Preview.css';

export default function CarouselComponent() {
  return (
    <div className="carousel-wrapper">
      <Carousel infiniteLoop useKeyboardArrows autoPlay>
        <div>
          <img src={images.retro3} alt="about_spoon" className="spoon__img" />
        </div>
        <div>
          <img src={images.retro5} alt="about_spoon" className="spoon__img" />
        </div>
        <div>
          <img src={images.retro1} alt="about_spoon" className="spoon__img" />
        </div>
        <div>
          <img src={images.retro2} alt="about_spoon" className="spoon__img" />
        </div>
        <div>
          <img src={images.retro4} alt="about_spoon" className="spoon__img" />
        </div>
        <div>
          <img src={images.retro6} alt="about_spoon" className="spoon__img" />
        </div>
      </Carousel>
    </div>
  );
}
